export { default as Switch } from './Switch';
export * as Styled from './Switch.styles';
export * from './Switch.types';
